module.exports = __webpack_public_path__ + "fonts/fa-brands-400.c1210e5.woff2";